import Node from './Node';
import Path from './Path';
import Player from './Player';
import GameScene from '../scenes/Game';
import { ComputerStrategy } from './ComputerStrategy';

export default class NodeManager {
    private relatedScene: GameScene;
    private nodes: Node[];
    private computerStrategy : ComputerStrategy;

    constructor(scene: GameScene, computerStrategy: ComputerStrategy) {
        this.relatedScene = scene;
        this.nodes = [];
        this.computerStrategy = computerStrategy;
    }

    public create(): void {
        this.nodes.forEach((node: Node) => {
            node.create();
        });
    }

    public all():  Node[] {
        return this.nodes;
    }

    public sumPopulationForPlayer(playerId: string): number {
        let sum = 0;
        this.nodes.forEach((node: Node) => {
            if (node.player.id === playerId && node.config.initPopulation) {
                sum += node.config.initPopulation;
            }
        });
        return sum;
    }

    public sumSupplyForPlayer(playerId: string): number {
        let sum = 0;
        this.nodes.forEach((node: Node) => {
            if (node.player.id === playerId && node.config.populationSupply !== -1) {
                sum += node.config.populationSupply;
            }
        });
        return sum;
    }

    public nearEnemyNodes(node: Node, paths: Path[]): Node[] {
        const nearNodes = this.nearNodes(node, paths);

        return nearNodes.filter((nearNode: Node) => {
            return (nearNode.player != node.player);
        });
    }

    public nearAlliedNodes(node: Node, paths: Path[]): Node[] {
        const nearNodes = this.nearNodes(node, paths);

        return nearNodes.filter((nearNode: Node) => {
            return (nearNode.player == node.player);
        });
    }

    public nearNodes(node: Node, paths: Path[]): Node[] {
        const nearNodes: Node[] = [];
        paths.forEach((path: any) => {
            if(path.origenNode == node) {
                nearNodes.push(path.destineNode);
            }

            if(path.destineNode == node) {
                nearNodes.push(path.origenNode);
            }
        });
        return nearNodes;
    }

    public computerNodes(): Node[] {
        return this.nodes.filter((node: Node) => {
            return (node.player.type == Player.computerType);
        });
    }

    public update(): void {
        this.nodes.forEach((node: Node) => {
            node.update();
        });
    }

    public add(id: string, x: number, y: number, player: Player, config: any): void {
 
        const gameMode = this.relatedScene.getBootloaderScene().globals.gameMode;

        this.nodes.push(
            gameMode === 'mobile'
                ? Node.createFromMobile(this.relatedScene, id, x, y, player, config)
                : Node.createFromDesktop(this.relatedScene, id, x, y, player, config) 
        );
    }
        

    public byId(id: string): Node {
        const node = this.nodes.find((node: Node) => {
            return node.id == id;
        });
        if (!node) {
            throw new Error(`Node Id ${id} not found`);
        }
        return node;
    }

    public lastPlayerIdInGame(): string | null {
        const playersInGame = this.playersInGame();
        if(playersInGame.length != 1) {
            return null;
        }
        return playersInGame[0].id;
    }
    
    public isPlayerInGame(playerId: string): boolean {
        const playersInGame = this.playersInGame();

        const playerFounded = playersInGame.find((playerInGame: Player) => {
            return playerInGame.id == playerId;
        });

        return playerFounded ? true : false;
    }

    private playersInGame(): Player[] {
        const playerIdsInGame: string[] = [];
        const playersInGame: Player[] = [];
        this.nodes.forEach((node: Node) => {
            if(node.player.type != Player.neutralType && !playerIdsInGame.includes(node.player.id)) {
                playerIdsInGame.push(node.player.id);
                playersInGame.push(node.player);
            } 
        });
        return playersInGame;
    }
        
    public advanceTime(): void {
        const pathMovements = this.computerStrategy.pathMovements(this, this.relatedScene.getPaths());
        
        for (const pathMovement of pathMovements) {
            pathMovement.execute();
        }
    }
}